/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { chatMessageModelSchema } from "./chatMessageModelSchema.ts";
import { z } from "zod";

export const chatMessageModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => chatMessageModelSchema))
    })